"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT_BASED = exports.SEAT_BASED = exports.PORTAL_BASED = exports.FREE = void 0;
var FREE = 'FREE';
exports.FREE = FREE;
var PORTAL_BASED = 'PORTAL_BASED';
exports.PORTAL_BASED = PORTAL_BASED;
var SEAT_BASED = 'SEAT_BASED';
exports.SEAT_BASED = SEAT_BASED;
var CONTACT_BASED = 'CONTACT_BASED';
exports.CONTACT_BASED = CONTACT_BASED;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/PurchaseTypes.js
// module id = 125
// module chunks = 5 6 7